// A single source of truth so the locally stored tenantId is read consistently

import { toSurveyManagerSlug } from './surveyManagerSlug';

const TENANT_STORAGE_KEY = 'tenantId';

export const SURVEY_PLAYER_TENANT_SLUG = 'survey-player';

export function slugifyTenant(value: string): string {
  return toSurveyManagerSlug(value);
}

export function parseTenantId(rawValue: string | null | undefined): string | undefined {
  if (rawValue === null || rawValue === undefined) {
    return undefined;
  }
  const trimmed = rawValue.trim();
  if (trimmed.length === 0) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(trimmed);
    if (typeof parsed === 'string' && parsed.length > 0) {
      return parsed;
    }
    if (typeof parsed === 'number' || typeof parsed === 'boolean') {
      return String(parsed);
    }
  } catch {
    // stored value was not JSON, fall through to plain-string
  }

  const stripped = trimmed.replace(/^['"]+|['"]+$/g, '');
  return stripped.length > 0 ? stripped : undefined;
}

/** Slugified tenant id used for survey-player / emapsite checks (develop). */
export function parseTenantIdSlug(tenantRaw: string | null): string {
  if (!tenantRaw) return '';

  try {
    return slugifyTenant(String(JSON.parse(tenantRaw)));
  } catch {
    return slugifyTenant(tenantRaw);
  }
}

export function isSurveyPlayerTenant(tenantRaw: string | null): boolean {
  return parseTenantIdSlug(tenantRaw) === SURVEY_PLAYER_TENANT_SLUG;
}

export function getTenantIdFromStorage(): string | undefined {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return undefined;
  }
  return parseTenantId(window.localStorage.getItem(TENANT_STORAGE_KEY));
}

export const TENANT_ID_STORAGE_KEY = TENANT_STORAGE_KEY;